module.exports = __webpack_public_path__ + "static/media/bg-darkgrey-top-right.c8dfc435.png";